import tw from 'tailwind-styled-components'

export const TwReactionList = tw.div`
  flex
  flex-wrap
  gap-8
`

export const TwReactionHint = tw.div`
  flex
  flex-col
  gap-4
  text-obscure-constant-old
  text-12
  leading-main
`

export const TwReactionHintItem = tw.div`
  flex
  items-center
  gap-8
`
